<template src="./Location.html">
</template>

<script>
import axios from "axios";
import * as common from "@/common.js";
import * as spaApi from "@/spaApi.js";
import { bpoffice } from "@/constants";

axios.defaults.headers.common['Pragma'] = 'no-cache';

export default {
    name: "location-component",
    props: {
      name:{
          type: String
      },
      parentPageName:{
          type: String,
          default: ''
      },
      locationData: {
          type: Object,
          default() {
              return {};
          }
      },
      bpUserLocation: {
        type: Object,
        default() {
          return {};
        }
      },
      clientInfo: {
        type: Object,
        default() {
          return {};
        }
      },
      disableControls: {
        type: Boolean
      },
      fireValidation: {
        type: Boolean,
        default() {
          return true;
        }
      },
      newClientFlag: {
        type: Boolean,
        default() {
          return true;
        }
      }
    },
    data() {
      return {
        matched: false,
        hasAccessToAllRegions: false,
        allregions: [],
        selectedRegionId: null,
        selectedOfficeId: null,
        selectedDepartmentId: null
      };
    },
    computed: {
      selectedRegion() {
        if (!this.allregions || !this.selectedRegionId) return null;
        return this.allregions.find(r => r.id === this.selectedRegionId) || null;
      },
      selectedOffice() {
        if (!this.selectedRegion || !this.selectedRegion.offices || !this.selectedOfficeId) {
          return null;
        }
          const office = this.selectedRegion.offices.find(o => o.id === this.selectedOfficeId) || null;
          return office;
        },
      selectedDepartment() {
        if (!this.selectedRegion || !this.selectedRegion.offices || !this.selectedOfficeId) {
          return null;
        }

        const office = this.selectedRegion.offices.find(o => o.id === this.selectedOfficeId);
        if (!office || !office.departments) return null;
        const dept =
          office.departments.find(d => d.id === this.locationData.departmentId) ||
          office.departments[0] ||
          null;

        return dept;
      }
    },
    mounted() {
        this.init();
    },
    watch: {
      locationData(newValues, oldValues) {
            const {
                officeId,
                officeName,
                departmentId,
                departmentName,
            } = this.locationData;
            const officeChange = newValues.officeId !== oldValues.officeId;
            const departmentChange = newValues.departmentId !== oldValues.departmentId;

            if (officeChange) this.officeData = common.buildDefaultOption(officeId, officeName);
            if (departmentChange) this.departmentData = common.buildDefaultOption(departmentId, departmentName);
      },
      clientInfo(newValue) {
        if (newValue) {
          this.selectedDepartmentId = newValue.departmentId
          this.selectedOfficeId = newValue.officeId
          this.selectedRegionId = newValue.regionId
          this.matched = true
        }
      },
      selectedOfficeId() {
        this.onOfficeChange()
      },
      selectedRegionId() {
        this.onRegionChange()
      },
      selectedDepartmentId(newId) {
        const d = this.selectedOffice.departments.find(x => x.id === newId);
        if (d) {
          this.locationData.departmentId = d.id;
          this.locationData.departmentName = d.name;
          this.departmentData = common.buildDefaultOption(d.id, d.name);
        }
      }

    },
    methods: {
      async init() {
        await spaApi.getAllRegions().then(x => {
          this.allregions = x
        })
        if (this.bpUserLocation.officeId === bpoffice.main) {
          this.hasAccessToAllRegions = true;
        }
        this.assignDefaults()
      },
      assignDefaults() {
        var result = this.regionByOfficeId(this.bpUserLocation.officeId)
        this.locationData.regionId = result.id
        this.selectedRegionId = result.id
        this.locationData.regionName = result.name
        const defaultOffice = result.offices.find(o => o.id === this.bpUserLocation.officeId) || null;
        this.selectedOfficeId = defaultOffice.id
        this.locationData.departmentId = defaultOffice.departments[0].id
        this.locationData.departmentName = defaultOffice.departments[0].name
      },
      onRegionChange() {
          var r = this.selectedRegion;
          this.locationData.regionId = r.id
          this.locationData.regionName = r.name
        if (r && r.offices && r.offices.length > 0) {
          this.selectedOfficeId = r.offices[0].id;
          this.selectedDepartmentId = r.offices[0].departments[0].id
        } else {
          this.selectedOfficeId = null;
        }
      },
      onOfficeChange() {
        var o = this.selectedRegion.offices.find(x => x.id === this.selectedOfficeId);
        if (o && o.departments && o.departments.length > 0) {
          var d = o.departments[0];
          this.selectedDepartmentId = (d.id != null ? d.id : d.name);
        } else {
          this.selectedDepartmentId = "";
        }
        if (o) {
            this.locationData.officeId = o.id;
            this.locationData.officeName = o.name;
            if (o.id && o.name) {
              this.officeData = common.buildDefaultOption(o.id, o.name);
            }
        } else {
          this.officeData = null;
        }
      },
      onDeptChange() {
        const d = this.selectedOffice.departments.find(x => x.id === this.selectedDepartmentId)
        if (d) {
          this.locationData.departmentId = d.id;
          this.locationData.departmentName = d.name;
          this.departmentData = common.buildDefaultOption(d.id, d.name);
        }
      },
      regionByOfficeId(officeId) {
        if (!this.allregions || officeId == null) return null;
        const toStr = v => (v == null ? null : String(v));
        const want = toStr(officeId);
        for (let i = 0; i < this.allregions.length; i++) {
          const r = this.allregions[i];
          if (!r || !r.offices) continue;
          for (let j = 0; j < r.offices.length; j++) {
            const o = r.offices[j];
            if (toStr(o.id) === want || toStr(o.name) === want) {
              return r; 
            }
          }
        }
        return null;
      },
    }
};

</script>
